import noMoreClick from "./noMoreClick";
var install = function install(Vue) {
  Vue.directive("noMoreClick", noMoreClick);
};
if (window.Vue) {
  window.clipboard = noMoreClick;
  Vue.use(install); // eslint-disable-line
}

noMoreClick.install = install;
export default noMoreClick;